import { useContext } from "react";
import { Context } from "../../../Store/Store";
import { NavLink } from "react-router-dom";

import Styles from "./Nav.module.css";
import { Button, IconButton, styled } from "@mui/material";

import { IoOptions} from "react-icons/io5";
import { FaPhoneAlt, FaFacebookF } from "react-icons/fa";
import { HiOutlineViewGrid } from "react-icons/hi";
import { MdGroups, MdOutlineCardGiftcard } from "react-icons/md";
import { LuHeadphones } from "react-icons/lu";
import { BiSolidMessageDetail } from "react-icons/bi";
import { FaLinkedinIn } from "react-icons/fa6";
import { MdOutlineRocketLaunch } from "react-icons/md";
import { mixpanelEvent } from "../../../Utils/mixpanelUtils";

const styles = {
  Nav: {
    display: "flex",
    flexDirection: "column",
    height: " 100%",
    gap: "5px",
    padding: 0,
    margin: 0,
  },
  SocialMediaBox: {
    display: "flex",
    alignItems: "center",
    gap: ".8rem",
    marginTop: "5px",
    padding: "0 0 0 12px",
  },
  SocialMedia: {
    background: "white",
    height: "26px",
    width: "26px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  SocialMediaIcon: {
    height: "18px",
    width: "18px",
    color: "#2f3eac",
  },

  UpgradeBtn: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    backgroundColor: "white",
    color: "#0A72C3",
    borderRadius: "10px",
    fontWeight: "600",
    fontFamily: "poppins",
    lineHeight: "20px",
    textTransform: "none",
    margin: "0 0 0 12px",
    padding: "8px 24px",
    textDecoration: "none",
    "&:hover": {
      background: "white",
      color: "#0A72C3",
      textDecoration: "none",
    },
  },
  ProIcon: {
    height: "18px",
    width: "18px",
  },
};

const StyledNavLink = styled(NavLink)(({ theme }) => ({
  "&:link, &:visited": {
    display: "flex",
    alignItems: "center",
    textAlign: "left",
    gap: "12px",
    color: "white",
    fontSize: "16px",
    fontWeight: "600",
    padding: "6px 12px",
    transition: "all 0.3s",
    textDecoration: "none",
  },

  "&:hover, &:active, &.active:link, &.active:visited": {
    color: "#0A72C3",
    backgroundColor: "white",
    borderRadius: "10px",
    textDecoration: "none",
  },
  "& svg": {
    width: "24px",
    height: "24px",
    color: "white",
    transition: "all 0.3s",
  },
  "&:hover svg, &:active svg, &.active:link svg, &.active:visited svg": {
    color: "#0A72C3",
  },
}));

function Nav() {
  const context = useContext(Context);
  const state = context[0];
  const premiumUser =
    state.user?.data?.group === "Premium" ||
    state.user?.data?.group === "Growth Plan" ||
    state.user?.data?.group === "Member" ||
    state.user?.data?.group === "Starter" ||
    state.user?.data?.group === "Trial";
  return (
    <ul style={styles.Nav}>
      <li>
        <StyledNavLink to="/Home">
          <HiOutlineViewGrid />
          <span>Sales Insights</span>
        </StyledNavLink>
      </li>
      <li
        onClick={() => {
          mixpanelEvent("left_navigation_clicked", {
            navigation_item: "Monitor",
            navigation_position: "header",
            screen_name: "Engagment community and software",
          });
        }}
      >
        <StyledNavLink to="/NurtureProspects">
          <MdGroups />
          <span>Prospect Feed</span>
        </StyledNavLink>
      </li>
      <li
        onClick={() => {
          mixpanelEvent("left_navigation_clicked", {
            navigation_item: "Customize AI",
            navigation_position: "header",
            screen_name: "Engagment community and software",
          });
        }}
      >
        <StyledNavLink to="/CustomizeAI">
          <IoOptions style={{ transform: "rotateY(180deg)", strokeWidth: "20px" }} />
          <span>Customize AI</span>
        </StyledNavLink>
      </li>
      {(state.user?.data?.group === "Member" || state.user?.data?.podAccess === true) && (
        <>
          <li
            onClick={() => {
              mixpanelEvent("left_navigation_clicked", {
                navigation_item: "Share",
                navigation_position: "header",
                screen_name: "Engagment community and software",
              });
            }}
          >
            <StyledNavLink to="/PodCommunity">
              <MdOutlineRocketLaunch />
              <span>Community</span>
            </StyledNavLink>
          </li>
        </>
      )}
      <li
        onClick={() => {
          mixpanelEvent("left_navigation_clicked", {
            navigation_item: "Refer and Earn",
            navigation_position: "header",
            screen_name: "Engagment community and software",
          });
        }}
      >
        <StyledNavLink to="/ReferAndEarn">
          <MdOutlineCardGiftcard />
          <span>Refer and Earn</span>
        </StyledNavLink>
      </li>
      {!premiumUser && (
        <li>
          <a style={{ display: "inline-block" }} href="https://bit.ly/45WJd7r" target="_blank" rel="noreferrer">
            <Button
              sx={styles.UpgradeBtn}
              variant="contained"
              onClick={() => {
              mixpanelEvent("upgrade_to_pro_clicked", {
                button_text: "Upgrade to Pro",
                page_section: "Sidebar",
                screen_name: "Engagment community and software",
              });
            }}
            >
              <img style={styles.ProIcon} src="/images/crown.svg" alt="pro icon" />
              <span>Upgrade to Pro</span>
            </Button>
          </a>
        </li>
      )}
      <li
        style={{ marginTop: "auto" }}
        onClick={() => {
          mixpanelEvent("support_link_clicked", {
            link_name: "Help & Strategy Hub",
            link_section: "sidebar",
            screen_name: "Engagment community and software",
          });
        }}
      >
        <a
          href="https://engage-ai.hiverkb.com/"
          target="_blank"
          rel="noreferrer"
          className={Styles.AnchorLink}
        >
          <LuHeadphones />
          <span>Help & Strategy Hub</span>
        </a>
      </li>
      <li
        onClick={() => {
          mixpanelEvent("support_link_clicked", {
            link_name: "Contact Us",
            link_section: "sidebar",
            screen_name: "Engagment community and software",
          });
        }}
      >
        <a
          href={
            state.user?.data?.group === "Growth Plan" || state.user?.data?.group === "Member"
              ? "https://tally.so/r/mDkRyN"
              : "https://www.facebook.com/groups/engageai"
          }
          target="_blank"
          rel="noreferrer"
          className={Styles.AnchorLink}
        >
          <FaPhoneAlt />
          <span>Contact Us</span>
        </a>
      </li>
      <li
        onClick={() => {
          mixpanelEvent("support_link_clicked", {
            link_name: "Feedback",
            link_section: "sidebar",
            screen_name: "Engagment community and software",
          });
        }}
      >
        <StyledNavLink to="/Feedback">
          <BiSolidMessageDetail />
          <span>Feedback</span>
        </StyledNavLink>
      </li>
      <li>
        <div style={styles.SocialMediaBox}>
          <a
            href="https://www.facebook.com/groups/engageai" target="_blank" rel="noopener noreferrer"
            onClick={() => {
              mixpanelEvent("support_link_clicked", {
                link_name: "social media - facebook",
                link_section: "sidebar",
                screen_name: "Engagment community and software",
              });
            }}
          >
            <IconButton style={styles.SocialMedia}>
              <FaFacebookF style={styles.SocialMediaIcon} />
            </IconButton>
          </a>
          <a
            href="https://www.linkedin.com/company/engage-ai-official/posts/?feedView=all"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              mixpanelEvent("support_link_clicked", {
                link_name: "social media - linkedin",
                link_section: "sidebar",
                screen_name: "Engagment community and software",
              });
            }}
          >
            <IconButton style={styles.SocialMedia}>
              <FaLinkedinIn style={styles.SocialMediaIcon} />
            </IconButton>
          </a>
        </div>
      </li>
    </ul>
  );
}

export default Nav;
